module.exports = __webpack_public_path__ + "static/media/Cooked_meat.657f3b98.png";